import React from "react";

import isIntuit from "Intuit/isIntuit";
import { useDispatch, useSelector } from "react-redux";

import { Modal, ModalHeader, ModalBody, ModalTitle, ModalFooter, closeModal, openModal } from "Cobalt/Modal";
import Button from "Common/Button";
import { Row, Col } from "Common/Grid";

import { WHY_REQUIRED_MODAL_NAME } from "./constants";
import { getModalName, useDocumentPickerContext, bem } from "./utils";

const WhyIsThisRequiredModal = () => {
  const { index, meta } = useDocumentPickerContext();
  const requirementReason = meta && meta.whyRequired ? meta.whyRequired : meta && meta.why_required ? meta.why_required : "";
  const currentlyOpenModal = useSelector((state) => state.openModal);
  const dispatch = useDispatch();
  const modalName = getModalName(WHY_REQUIRED_MODAL_NAME, index);

  return (
    <Modal show={currentlyOpenModal === modalName} onHide={() => dispatch(closeModal(modalName))} aria-hidden={currentlyOpenModal !== modalName}>
      <ModalHeader closeButton>
        <ModalTitle>Why is this document required?</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col>{requirementReason}</Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color={isIntuit() ? "gray" : "blue"} {...(isIntuit() ? { size: "medium" } : {})} onClick={() => dispatch(closeModal(modalName))}>
          Continue
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const WhyIsThisRequiredTrigger = () => {
  const dispatch = useDispatch();
  const { index } = useDocumentPickerContext();

  return (
    <Button color="link" className={bem("InfoLink")} onClick={() => dispatch(openModal(getModalName(WHY_REQUIRED_MODAL_NAME, index)))}>
      Why is this required?
    </Button>
  );
};

const WhyIsThisRequired = () => (
  <>
    <WhyIsThisRequiredTrigger />
    <br />
    <WhyIsThisRequiredModal />
  </>
);

export default WhyIsThisRequired;
